module.exports = __webpack_public_path__ + "img/arrow-down-left-circle.306e0933.svg";